import React from 'react';

import { ContentSelectorsContainer } from './styledComponents';

export const FullScreenModalContentSelectors = (props) => (
  <ContentSelectorsContainer>{props.children}</ContentSelectorsContainer>
);

export default FullScreenModalContentSelectors;
